import React from 'react';

import { NameAvatar } from '@r123/ui';
import { useTranslations } from 'next-intl';

import { DEFAULT_IMAGE } from '@/app/_constant/component.constant';
import { cn } from '@/app/_helper/tailwind';
import { Property } from '@/modules/core/gql/generated';

import OrganizationLogo from '../OrganizationLogo';
import Avatar from './Avatar';
import LastUpdateInfo from './LastUpdateInfo';

type AgentInfoProps = {
    agent: Property['agent'];
    time: Property['time'];
    isSmall?: boolean;
    isSmallSRPCard?: boolean;
};
const AgentInfo = ({
    agent,
    time,
    isSmall = false,
    isSmallSRPCard,
}: AgentInfoProps) => {
    const [falseUrl, setFalseUrl] = React.useState('');
    const t = useTranslations('srp.agentInfo');

    const url = agent?.medias?.[0]?.mediaInfo?.[0]?.formatUrl || DEFAULT_IMAGE;
    const urlOrganization =
        agent?.organization?.medias?.[0]?.mediaInfo?.[0]?.formatUrl || '';

    const getRole = () => {
        if (agent?.attributes?.isHomeOwner) return t('homeowner');
        if (
            !agent?.organization?.name ||
            agent?.organization.name?.includes('Independent')
        )
            return t('independent');
        return t('corporate');
    };

    return (
        <div className='flex flex-1 items-center gap-x-2 [&>.flex]:flex-shrink-0 min-w-0'>
            <NameAvatar
                agentImageUrl={(falseUrl || url)
                    .replace('{width}x{height}-{scale}', '180x180-fit')
                    .replace('/180/', '/')}
                name={agent?.name || ''}
                size={42}
            >
                <Avatar
                    src={url
                        .replace('{width}x{height}-{scale}', '180x180-fit')
                        .replace('/180/', '/')}
                    alt={agent?.name || ''}
                    onCallbackError={() => {
                        setFalseUrl('/');
                    }}
                />
            </NameAvatar>

            <div className='min-w-0 flex-0' data-name="agent-container">
                <LastUpdateInfo className='overflow-hidden whitespace-nowrap text-ellipsis' time={time} />
                <div className='flex items-center gap-x-1 min-w-0'>
                    <p
                        className={cn(
                            'text-sm text-accent font-medium leading-6 overflow-hidden whitespace-nowrap text-ellipsis',
                            {
                                'md:truncate md:max-w-[75%]': isSmallSRPCard,
                            },
                        )}
                    >
                        {agent?.name}
                    </p>
                    {getRole() !== t('corporate') && !isSmallSRPCard && (
                        <>
                            <div className='flex-none size-1 bg-[#D9D9D9] rounded-full'></div>
                            <p className='flex-auto md:flex-1 mb-0 text-[#868D9A] text-sm overflow-hidden whitespace-nowrap text-ellipsis'>
                                {getRole()}
                            </p>
                        </>
                    )}
                </div>
            </div>
            {getRole() === t('corporate') &&
                urlOrganization &&
                !isSmallSRPCard && (
                    <OrganizationLogo
                        className={cn({
                            'flex-auto md:flex-1 ml-auto md:ml-0 md:h-10 flex justify-end md:grow md:max-w-full': true,
                            'md:justify-center md:px-2': !isSmall,
                        })}
                        src={urlOrganization.replace(
                            '{width}x{height}-{scale}',
                            '170x170-fit',
                        )}
                        alt={agent?.organization?.name || ''}
                    />
                )}
        </div>
    );
};

export default AgentInfo;
